class BasePartial {
  setup () {
    throw 'Not implemented'
  }
}

export default BasePartial